import { useEffect, useState } from "react";
import { http } from "@/lib/api";

// Generic hook to consume editable static page content (home, configurator, contact, ...)
export const usePageContent = (pageKey) => {
  const [content, setContent] = useState({});

  useEffect(() => {
    let active = true;
    http
      .get(`/page-content/${pageKey}`)
      .then((r) => {
        if (active) setContent(r.data || {});
      })
      .catch(() => {});
    return () => {
      active = false;
    };
  }, [pageKey]);

  return content;
};
